var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showAdminModal
    ? _c("div", { staticClass: "admin-modal", on: { click: _vm.closeModal } }, [
        _c(
          "div",
          {
            staticClass: "admin-card",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "admin-content" }, [
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("添加物品")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "item-input-container" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.itemName,
                          expression: "itemName",
                        },
                      ],
                      ref: "itemNameInput",
                      attrs: { placeholder: "物品名称" },
                      domProps: { value: _vm.itemName },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.itemName = $event.target.value
                          },
                          _vm.onItemNameInput,
                        ],
                        focus: _vm.onItemFocus,
                        blur: _vm.hideSuggestions,
                        keydown: _vm.handleItemKeyDown,
                      },
                    }),
                    _vm._v(" "),
                    _vm.showItemSuggestions && _vm.filteredItems.length > 0
                      ? _c(
                          "div",
                          { staticClass: "item-suggestions" },
                          _vm._l(_vm.filteredItems, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: item.name,
                                class: [
                                  "item-suggestion",
                                  { active: index === _vm.selectedItemIndex },
                                ],
                                on: {
                                  mousedown: function ($event) {
                                    return _vm.selectItem(item.name)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.name) +
                                    " (" +
                                    _vm._s(item.description) +
                                    ")\n            "
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.itemCount,
                        expression: "itemCount",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", placeholder: "数量", min: "1" },
                    domProps: { value: _vm.itemCount },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.itemCount = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.addItem } }, [
                    _vm._v("添加物品"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("设置属性")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("label", [_vm._v("修为等级:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerRealm,
                        expression: "playerRealm",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0", max: "6" },
                    domProps: { value: _vm.playerRealm },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerRealm = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("阶段:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerSubstage,
                        expression: "playerSubstage",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0", max: "3" },
                    domProps: { value: _vm.playerSubstage },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerSubstage = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("经验:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerXp,
                        expression: "playerXp",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerXp },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerXp = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.setCultivation } }, [
                    _vm._v("设置修为"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("label", [_vm._v("气血:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerQi,
                        expression: "playerQi",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerQi },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerQi = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("最大气血:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerMaxQi,
                        expression: "playerMaxQi",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerMaxQi },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerMaxQi = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.setQi } }, [
                    _vm._v("设置气血"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("label", [_vm._v("攻击:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerAttack,
                        expression: "playerAttack",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerAttack },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerAttack = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("防御:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerDefense,
                        expression: "playerDefense",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerDefense },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerDefense = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.setCombat } }, [
                    _vm._v("设置战斗属性"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("label", [_vm._v("法力:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerMana,
                        expression: "playerMana",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerMana },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerMana = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("神识强度:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.playerDivineSense,
                        expression: "playerDivineSense",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", min: "0" },
                    domProps: { value: _vm.playerDivineSense },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerDivineSense = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.setSpiritual } }, [
                    _vm._v("设置灵力属性"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("label", [_vm._v("位置:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.playerLocation,
                        expression: "playerLocation",
                      },
                    ],
                    attrs: { placeholder: "位置名称" },
                    domProps: { value: _vm.playerLocation },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.playerLocation = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.setLocation } }, [
                    _vm._v("设置位置"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("添加技能")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.skillName,
                        expression: "skillName",
                      },
                    ],
                    attrs: { placeholder: "技能名称" },
                    domProps: { value: _vm.skillName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.skillName = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.skillLevel,
                        expression: "skillLevel",
                        modifiers: { number: true },
                      },
                    ],
                    attrs: { type: "number", placeholder: "等级", min: "1" },
                    domProps: { value: _vm.skillLevel },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.skillLevel = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("button", { on: { click: _vm.addSkill } }, [
                    _vm._v("添加技能"),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("其他功能")]),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "danger", on: { click: _vm.resetGame } },
                  [_vm._v("重置游戏")]
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.saveGame } }, [
                  _vm._v("保存游戏"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "admin-footer" }, [
              _c("button", { on: { click: _vm.closeModal } }, [_vm._v("关闭")]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "admin-header" }, [
      _c("h3", [_vm._v("管理员控制中心")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }